export default __webpack_public_path__ + "static/media/logo-ae-6thstreet.adfe959d.svg";